export const NODE_NAME = 'spacer';
